<template>
  <el-dialog
    custom-class="action-modal"
    :append-to-body="true"
    title="Integrate MixPanel project"
    :visible.sync="isVisible"
    width="40%"
    @close="close"
  >
    <div :class="$style.container">
      <div :class="$style.layer"></div>
      <div :class="$style.field">
        <p :class="$style.title">Mixpanel Project ID</p>
        <p :class="$style.subtext">
          The Project ID can be found in Mixpanel in the Overview section of the Project Settings.
        </p>
        <el-input v-model="projectId" placeholder="Enter your MixPanel Project ID"/>
      </div>
      <p :class="$style.title">Mixpanel Service Account</p>
      <div :class="$style.subsection">
        <div :class="$style.field">
          <p :class="$style.subtitle">Service Account name</p>
          <p :class="$style.subtext">
            You can create a Service Account in Mixpanel in the Service Accounts section of the Project Settings.
          </p>
          <el-input v-model="serviceAccountName" size="small" placeholder="Enter the Service Account name"/>
        </div>
        <div :class="$style.field">
          <p :class="$style.subtitle">Service Account secret</p>
          <el-input
            v-model="serviceAccountSecret"
            type="password"
            placeholder="Enter the Service Account secret"/>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button :disabled="isValidating" @click="close">Cancel</el-button>
      <el-button type="primary" :disabled="!canValidate || isValidating" @click="validate">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import actionList from '@/static/actionList';
import { cloneDeep } from 'lodash';

export default {
  name: 'LinkMixPanelModal',
  components: {},
  props: {
    game: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: 'no name',
    },
    current: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    step: {
      type: Object,
      default: null,
    },
    steps: {
      type: Array,
      default: null,
    },
    warning: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isVisible: true,
      isValidating: false,
      actionList,
      errorBack: [],
      projectId: this.game?.mixpanel?.projectId ?? '',
      serviceAccountName: this.game?.mixpanel?.serviceAccountName ?? '',
      serviceAccountSecret: '',
    };
  },
  computed: {
    codification() {
      return this.$store.getters['users/codification'] || null;
    },
    canValidate() {
      return this.serviceAccountSecret && this.serviceAccountName && this.projectId;
    },
  },
  methods: {
    close() {
      this.isVisible = false;
      this.$emit('close');
    },
    async validate() {
      this.isValidating = true;

      try {
        await this.integrateMixPanel({
          projectId: this.projectId,
          serviceAccountName: this.serviceAccountName,
          serviceAccountSecret: this.serviceAccountSecret,
        });
      } catch {
        return;
      }

      this.close();
    },
    integrateMixPanel({
      projectId,
      serviceAccountName,
      serviceAccountSecret,
    }) {
      return new Promise(async (resolve, reject) => {
        const action = this.actionList.filter(
          el => el.id === 'integrate_mix_panel',
        )[0];
        action.post.field[0].value = projectId;
        action.post.field[1].value = serviceAccountName;
        action.post.field[2].value = serviceAccountSecret;
        const param = {
          id: cloneDeep(this.game.id),
          action,
        };
        const response = await this.$store.dispatch(
          'ActionToDispatch/dispatchAction',
          param,
        );
        if (response.isSuccess) {
          resolve(true);
        } else {
          const errorList = this.codification.errorList;
          this.errorBack = [errorList.GAME_ANALYTICS_GAME_NOT_FOUND.message];
          reject(response.reason);
        }
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: block;

  h2 {
    font-size: 16px;
    padding-bottom: 16px;
    text-align: left;
  }
}

.title {
  margin: $spacing 0;
  font-size: 12px;
  font-weight: 600;
}

.subtitle {
  margin: $spacing 0 $spacing 0;
  font-size: 12px;
  font-weight: 600;
}

.subtext {
  color: $grey;
  font-size: 12px;
  line-height: 1;
  margin: $spacing 0 $spacing 0;
}

.subsection {
  padding-left: $spacing * 2;
}

.validateBtn {
  margin-top: $spacing * 3;
}

.notice {
  margin-top: $spacing * 3;
}

.field {
  margin: $spacing * 2 0;
}
</style>
